import React from "react";
import { RatingReviewDetailEntryLinkView } from "./view";
import { styles } from "./styles";

export const RatingReviewDetailEntryLink = props => (
  <RatingReviewDetailEntryLinkView {...props} styles={styles} />
);
